import React, { ReactNode } from "react"
import NavBar from "../nav-bar"
import {
  FNavigationBarFragment,
  IBanner,
  ILink,
  IMediaAsset,
  INavigationBar
} from "../../../gatsby-graphql"
import NavBarRwd from "../nav-bar-rwd"
import {
  HeaderWrapper,
  VideoBackground,
  ContentWrapper,
  Content,
  ButtonWrapper,
  Description,
} from "./header-elements"
import { Button, Heading } from "../../ui"
import { ButtonType } from "../../ui/button/button-elements"
import { getMediaType } from "../../helpers/get-media"
import { ILocaleLink } from "../top-bar/common/Locales"

interface HeaderProps {
  data: IBanner
  navBarData: FNavigationBarFragment
  className?: string
  children?: ReactNode
  locales?: ILocaleLink[]
  rwdLogo?: IMediaAsset
  locale?: string
}

const getDefaultContent = (data: IBanner, locale?: string) => {
  return (
    <>
      <Heading.H1>{data.title}</Heading.H1>
      {data.description && <Description>{data.description}</Description>}
      {data.buttons && data.buttons.length > 0 && (
        <ButtonWrapper>
          {data.buttons.map((button, index) => (
            <Button
              type={button?.type as ButtonType}
              link={button?.link as ILink}
              locale={locale}
              key={index}
            />
          ))}
        </ButtonWrapper>
      )}
    </>
  )
}

const Header = ({
  data,
  navBarData,
  className,
  children,
  locales,
  rwdLogo,
                  locale,
}: HeaderProps) => {
  if (data == null) {
    return null;
  }
  const bgType = getMediaType(data.background?.mime as string)
  return (
    <HeaderWrapper
      bgImg={
        data.background?.localFile?.childImageSharp?.gatsbyImageData?.images
          ?.fallback?.src || ""
      }
      className={className || "default"}
    >
      {bgType === "VIDEO" && (
        <VideoBackground
          autoPlay
          muted
          loop
          src={data.background?.url as string}
        />
      )}
      <ContentWrapper>
        {navBarData && !navBarData.isHidden && <NavBar data={navBarData} locale={locale} />}
        {navBarData && !navBarData.isHidden && <NavBarRwd data={navBarData} locales={locales} logo={rwdLogo} locale={locale} />}
        <Content className={className || "default"}>
          {children || getDefaultContent(data, locale)}
        </Content>
      </ContentWrapper>
    </HeaderWrapper>
  )
}

export default Header
